<template>
  <div>
  <div class="group-rounded-box my-3 mx-4">
    <span class="title">Filters</span>

    <!-- ROW -->
    <div class="row">
      <!-- DATE SELECTION -->
      <div class="col-md-4 col-sm-12" :class="{ 'mt-2': $breakpoint.mdAndDown }">
        <label for="selectProduct">Date</label>
        <div class="position-relative">
          <el-date-picker
            class="mr-2"
            v-model="selectedDate"
            type="date"
            placeholder="Select Date"
            @change="refreshPriceQuotes"
          >
          </el-date-picker>
        </div>
      </div>
      <!-- CUSTOMER SELECTION -->
      <div class="col-md-4 col-sm-12" :class="{ 'mt-2': $breakpoint.mdAndDown }">
        <label for="selectProduct">Customer</label>
        <div class="position-relative">
          <el-select
            class="el-olf"
            @change="changeCustomer"
            v-model="selectedCustomer"
            value-key="id"
            placeholder="Select Customer"
            filterable
            collapse-tags
            clearable
          >
            <el-option v-for="item in getCustomers" :key="item.id" :label="item.name" :value="item"></el-option>
          </el-select>
        </div>
      </div>
      <div class="col-md-4" :class="{ 'mt-2': $breakpoint.mdAndDown }" style="padding-top:23px;">
        <button 
          class="btn btn-actionable"
          @click="resetFilters"
        >
          Reset Filters
        </button>
      </div>
    <!-- ROW -->
    </div>
  </div>
    <div class="group-rounded-box my-0 mx-4">
    <span class="title">Price Quotes</span>
    <div class="row">
      <div class="col-md-12">
        <div class="table-container table-responsive">
          <div v-if="priceQuotes.length === 0" class="w-100 alert tables-alert-custom-message-notify mt-3 text-center">
            <i class="fas fa-info-circle mr-2"></i>
            You have not created any price quotes
          </div>
          <table v-else class="table no-border">
            <thead>
              <tr>
                <th v-for="(item, key) of tableTitles" :key="key">
                  {{ item.title }}
                </th>
              </tr>
            </thead>
            <tbody v-for="(priceQuote, priceQuoteKey) of priceQuotesFormatted" :key="priceQuoteKey">
              <tr v-for="(item, itemKey) of priceQuote.basketItems" :key="itemKey">
                <td v-if="itemKey === 0" :rowspan="priceQuote.basketItems.length">
                  {{ priceQuote.created | datetimeformat }}
                </td>
                <td v-if="itemKey === 0" :rowspan="priceQuote.basketItems.length">
                  {{ priceQuote.customerName }}
                </td>
                <template v-if="priceQuote.terminalId">
                  <td v-if="itemKey === 0" :rowspan="priceQuote.basketItems.length">
                    {{ priceQuote.terminalId | terminalsname }}
                  </td>
                </template>
                <td class="p-1" v-else>{{ item.networkId | networksname }}</td>
                <td>{{ item.productId | fueltype }}</td>
                <td>{{ item.quantity | volumeformat }}</td>
                <td v-if="itemKey === 0" :rowspan="priceQuote.basketItems.length"> 
                {{ priceQuote.haulageRate || "-" }} 
                </td>
                <td class="p-1">{{ item.quotePrice | priceformat }}</td>
                <td v-if="itemKey === 0" :rowspan="priceQuote.basketItems.length">
                  <span
                    v-if="priceQuote.status !== ePriceQuoteStatus.open"
                    :class="{
                      'text-t_green': priceQuote.status === ePriceQuoteStatus.orderPlaced,
                      'text-t_red': priceQuote.status === ePriceQuoteStatus.expired,
                    }"
                  >
                    {{ priceQuote.status }}
                  </span>
                  <price-quote-countdown
                    v-else
                    :startTime="priceQuote.timeLeft"
                    :priceQuoteId="priceQuote._id"
                    @set-to-expired="setPriceQuoteStatusToExpired"
                  ></price-quote-countdown>
                </td>
                <td v-if="itemKey === 0" :rowspan="priceQuote.basketItems.length">
                  <button
                    :class="{
                      invisible:
                        priceQuote.status === ePriceQuoteStatus.expired ||
                        priceQuote.status === ePriceQuoteStatus.orderPlaced,
                    }"
                    @click="$emit('add-to-basket', priceQuote)"
                    class="btn btn-sm btn-confirm"
                  >
                    Add to Basket
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
          <el-row class="pt-3">
            <el-col :xs="12" :sm="12" :md="12" :lg="12" class="pt-1">
              <paginate
                class="float-left"
                v-model="getPageNumber"
                :page-count="totalPages"
                :click-handler="refreshPriceQuotes"
                :prev-text="'Prev'"
                :next-text="'Next'"
                :container-class="'pagination bg-white'"
                :page-class="'pagination-item'"
                :page-link-class="'border-right-0'"
                :prev-class="'pagination-item pagination-prev rounded-sm rounded-sm-left'"
                :next-class="'pagination-item pagination-next rounded-sm rounded-sm-right'"
                :active-class="'active'"
                :disabled-class="'btn-disabled bg-disabled'"
              >
              </paginate>
            </el-col>
            <!-- <el-col
              :xs="12"
              :sm="7"
              :md="8"
              :lg="8"
              :xl="9"
              class="pt-2"
              :class="{ 'mt-1': !$breakpoint.smAndDown }"
              align="right"
              justify="right"
              v-if="!$breakpoint.smAndDown"
            >
            </el-col>
            <el-col :xs="12" :sm="5" :md="4" :lg="4" :xl="3" class="pt-1" align="right" justify="right">
              <fieldset class="form-group mt-0 pr-5 text-right" id="__BVID__99">
                <label class="mt-2 mr-2 d-inline-block text-right text-platform-default">Show</label>
                <div tabindex="-1" role="group" class="float-right">
                  <div role="radiogroup" tabindex="-1" class="btn-group-toggle btn-group">
                    <label
                      class="btn"
                      :class="{
                        'btn-neutral text-white': pageLimit == 10,
                        'btn-outline-t_greyish-blue text-platform-default bg-white': pageLimit != 10,
                      }"
                    >
                      <input
                        type="radio"
                        name="limit-buttons"
                        autocomplete="off"
                        v-model="pageLimit"
                        value="10"
                        @change="setPageLimit(10)"
                      />
                      <span>10</span>
                    </label>
                    <label
                      class="btn"
                      :class="{
                        'btn-neutral text-white': pageLimit == 15,
                        'btn-outline-t_greyish-blue text-platform-default bg-white': pageLimit != 15,
                      }"
                    >
                      <input
                        type="radio"
                        name="limit-buttons"
                        autocomplete="off"
                        v-model="pageLimit"
                        value="15"
                        @change="setPageLimit(15)"
                      />
                      <span>15</span>
                    </label>
                  </div>
                </div>
              </fieldset>
            </el-col> -->
          </el-row>
        </div>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
import breakpoint from "@/mixins/index";
import { mapGetters } from "vuex";
import { debounce } from "lodash";
import { eBasketStatus } from "@/util/enums/basket";

import PriceQuoteCountdown from "./PriceQuoteCountdown.vue";
import { getSellerPriceQuotes } from "@/api/priceQuotes";

export default {
  mixins: [breakpoint],
  components: { PriceQuoteCountdown },
  data() {
    return {
      priceQuotes: [],
      totalPages: 0,
      pageNumber: 1,
      selectedCustomer: "",
      selectedDate: new Date(),
      priceQuotesFormatted: [],
      tableTitles: [
        { title: "Time" },
        { title: "Customer" },
        { title: "Terminal" },
        { title: "Product" },
        { title: "Volume" },
        { title: "Haulage ppl" },
        { title: "Price ppl" },
        { title: "Expiry" },
        { title: "Add" },
      ],
      ePriceQuoteStatus: {
        open: "open",
        expired: "expired",
        orderPlaced: "order placed",
      },
      eBasketStatus,
    };
  },
  created() {
    this.refreshPriceQuotes();
  },
  watch: {
    priceQuotes: {
      handler: function (priceQuotesList) {
        this.priceQuotesFormatted = this.formatPriceQuotes(priceQuotesList);
      },
    },
  },
  computed: {
    ...mapGetters("accounts", ["customerList"]),
    ...mapGetters("orderCapture", ["isContract"]),
    getCustomers() {
      return this.customerList.map(({ id, name }) => { return { id, name }});
    },
    getPageNumber: {
      set(val) {
        this.pageNumber = val;
      },
      get() {
        return this.pageNumber;
      }
    },
    // returns the selected date in UTC to avoid any timezome issues
    formattedDate: function() {
        let date = new Date(this.selectedDate);
        const monthString = date.getMonth() <= 8 ? `0${date.getMonth() + 1}` : `${date.getMonth() + 1}`;
        return `${date.getFullYear()}-${monthString}-${date.getDate().toString().padStart(2, "0")}T00:00:00Z`;  
    }
  },
  methods: {
    formatPriceQuotes: function (priceQuotesList) {
      return priceQuotesList
        .map(({ _id, basket, expires, created }) => {
          const { account_id, status: basketStatus, haulageRate = 0 } = basket;
          const { name: customerName = "-" } = this.customerList.find(({ id }) => id === account_id) || {};
          const terminalId = basket.items[0].terminalId;
          const timeLeft = (new Date(expires) - new Date()) / 1000;

          const basketItems = basket.items.map((item) => {
            const { price, adjustment } = item;
            return { ...item, quotePrice: price + adjustment + haulageRate };
          });

          return {
            _id,
            created,
            basket,
            customerName,
            terminalId,
            haulageRate,
            basketItems,
            timeLeft,
            status: this.setPriceQuoteStatus(basketStatus, timeLeft),
          };
        })
        .sort((first, second) => -(first.timeLeft - second.timeLeft));
    },
    setPriceQuoteStatus: function (basketStatus, timeLeft) {
      if (basketStatus === eBasketStatus.Ordered) {
        return this.ePriceQuoteStatus.orderPlaced;
      }
      if (timeLeft < 1) {
        return this.ePriceQuoteStatus.expired;
      }
      return this.ePriceQuoteStatus.open;
    },
    setPriceQuoteStatusToExpired(priceQuoteId) {
      const expiredPriceQuote = this.priceQuotesFormatted.find(({ _id }) => _id === priceQuoteId);
      if (expiredPriceQuote) {
        expiredPriceQuote.status = this.ePriceQuoteStatus.expired;
      }
    },
    refreshPriceQuotes: debounce(async function() {
      const dto = {
        pageNumber: this.pageNumber,
        buyerAccountId: this.selectedCustomer ? this.selectedCustomer.id : undefined,
        date: this.selectedDate ? this.formattedDate : undefined,
        isContract: this.isContract
      }
      const priceQuoteResult = await getSellerPriceQuotes(dto);
      this.priceQuotes = priceQuoteResult.priceQuotes || [];
      if (priceQuoteResult.metadata) {
        this.pageNumber = priceQuoteResult.metadata.pageNumber;
        this.totalPages = priceQuoteResult.metadata.pageCount;
      }
    }, 100),
    changeCustomer: function(val) {
      this.selectedCustomer = val;
      this.refreshPriceQuotes();
    },
    resetFilters: function() {
      this.selectedCustomer = "";
      this.selectedDate = new Date();
      this.refreshPriceQuotes();
    }
  },
};
</script>

<style lang="scss" scoped>
tr > th,
td {
  vertical-align: center;
  text-align: center;
}
.no-border td {
  border: none;
}
</style>
